import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '@/lib/api';

const SiteContentContext = createContext(null);

export const useSiteContent = () => {
  const context = useContext(SiteContentContext);
  if (!context) {
    throw new Error('useSiteContent must be used within SiteContentProvider');
  }
  return context;
};

export const SiteContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const data = await api.getSiteContent();
        setContent(data);
        // NOTE: SEO tags (title, description, og:*) are now handled per-page via react-helmet-async
        // Do NOT set document.title or meta description here - it overrides page-specific SEO
      } catch (err) {
        console.error('Failed to fetch site content:', err);
      } finally {
        setLoading(false);
      }
    };
    
    fetchContent();
  }, []);

  const refreshContent = async () => {
    try {
      const data = await api.getSiteContent();
      setContent(data);
    } catch (err) {
      console.error('Failed to refresh content:', err);
    }
  };

  return (
    <SiteContentContext.Provider value={{ content, loading, refreshContent }}>
      {children}
    </SiteContentContext.Provider>
  );
};

export default SiteContentContext;
